import { render, staticRenderFns } from "./HomeWorkCard.vue?vue&type=template&id=70ce1eb6"
import script from "./HomeWorkCard.vue?vue&type=script&lang=js"
export * from "./HomeWorkCard.vue?vue&type=script&lang=js"
import style0 from "./HomeWorkCard.vue?vue&type=style&index=0&id=70ce1eb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports